import { usePremiumContext } from "@/contexts/PremiumContext";

interface PremiumStatus {
  isPremium: boolean;
  /** Real paid/native premium — use this for ad gating, not isPremium. */
  isPaidPremium: boolean;
  loading: boolean;
  expiresAt: string | null;
  refresh: () => Promise<void>;
}

/**
 * Hook to access premium status.
 * Reads from PremiumContext — single DB query shared across all consumers.
 * Premium is computed from subscriptions.expires_at > now(), never localStorage.
 */
export const usePremiumStatus = (): PremiumStatus => {
  return usePremiumContext();
};
